export default class Bands {
    constructor(bands) {
        this.bands = bands;
    }

    getRate(band) {
        return (band in this.bands) ? this.bands[band].rate : 0;
    }

    getMin(band) {
        return (band in this.bands) ? this.bands[band].min : 0;
    }

    getMax(band) {
        return (band in this.bands) ? this.bands[band].max : 0;
    }
}